import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebaseの設定
const firebaseConfig = {
    apiKey: "AIzaSyDoOnFpx2MC14M9fM3z826i8yvsW0zCiX4",
    authDomain: "toimap-demo.firebaseapp.com",
    projectId: "toimap-demo",
    storageBucket: "toimap-demo.appspot.com",
    messagingSenderId: "301324745721",
    appId: "1:301324745721:web:bb36efa4569d4f3f509b28",
    measurementId: "G-2QEQKHEPKT"
};

// Firebaseアプリを初期化
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

// auth（認証）に関する記述をすべて削除

export { db, storage }; // auth をエクスポートから削除